export enum CrmExportType {
  FILTER = 'FILTER',
  ALL = 'ALL',
  CURRENT_PAGE = 'CURRENT_PAGE'
}
